import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import { Container, Row, Col, Table } from "react-bootstrap";


function Main(props) {
    
    const [activeIndex, setActiveIndex] = useState(props.activeIndex);

    const handleToggle = (index) => {
       
        setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    const InternsApprentice = 

    [
         {
            AdvertisementDate: <> 19.03.2026 </>,
            NameofthePost: <>Graduate Apprentice (26 Positions)<br/><br/>Technician (Diploma Apprentice) (14 Positions)</>,
            Advertisement:[ {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2026/IITTPAPPRENTICESHIP2026-2701_Notification.pdf",
                Text: "Advertisement for 1-year Apprenticeship Training Programme for Graduate/Diploma under NATS",
                Style: {
                    color: "blue"
                }
               
            },
        ],
            Application: [
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2026/IITTPAPPRENTICESHIP2026-2701_Application_Form.pdf",
                    Text: "Click here to download",
                    glowstatus : "yes"
                    
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>27,28,29 March 2026</>,
            Status:
            [ 
            {
                  Link: "https://files.iittp.ac.in/pdfs/announcements/2026/IITTPACRESULT2026_01_Apprentice_Selection_Results.pdf",
                Text: "Selected Candidates List",
                color: {
                    color: "darkgreen",
                    "text-align": "justify",
                    
                },
                glowstatus : "yes"
            }
           
        ]
        },

        


         {
            AdvertisementDate: <> 27.02.2026 </>,
            NameofthePost: "Summer Internship for Students (90 positions)",
            Advertisement:[ {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2026/Summer_Internship_2026_Flyer.pdf",
                Text: "Notification for two months of Summer Internship at IIT Tirupati",
                Style: {
                    color: "blue"
                }
               
            },
        ],
            Application: [
                {
                    Link: "https://iittp.plumerp.co.in/prod/iittirupati/internrp",
                    Text: "Click here to apply",
                    
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission of application: 30.03.2026 @5:00 PM</>,
            Status:
            [ 
            {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2026/Summer_Internship_2026_Selection_List.pdf",
                Text: "Selected Students List",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                },
                glowstatus: "yes"
            },
           
        ]
        },


         {
            AdvertisementDate: <> 17.12.2025 </>,
            NameofthePost: "Junior Library Executive (04 positions)",
            Advertisement:[ {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTLIB-INTERNAdvt_2025-2601_Junior_Library_Executive.pdf",
                Text: "Notification for the position of Junior Library Executive (Period of two years on contract) at IIT Tirupati.",
                Style: {
                    color: "blue"
                }
               
            },
        ],
            Application: [
                {
                    Link: "https://forms.gle/pDQyz6HLBwzFzGSL6",
                    Text: "Click here to apply",
                 
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 31.12.2025</>,
            Status:
            [
                {
                Link: "#",
                Text: "Shortlisting Status",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                },
                glowstatus: "no",
                strikeOut: "yes"
            }, 
             {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/ShortlistingResult_JLE_Updated.pdf",
                Text: "Shortlisting Status Updated",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                },
                // glowstatus: "no"
            },
            {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/ScreeningResult_JLE.pdf",
                Text: "Screening Test Result",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                },
                // glowstatus: "yes"
            },
            {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTPLIBJLE-20262025-2602_Results_JLE_2025.pdf",
                Text: "Selected Candidates List",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                },
                glowstatus: "yes"
            },
            
           
        ]
        },
        
        {
            AdvertisementDate: <> 05.03.2025 </>,
            NameofthePost: "Summer Internship for Students (90 positions)",
            Advertisement:[ {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/Summer_Internship_2025_Flyer.pdf",
                Text: "Notification for two months of Summer Internship at IIT Tirupati",
                // Style: {
                //     color: "blue"
                // }
               
            },
        ],
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    glowstatus : "no"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 31.03.2025</>,
            Status:
            [ 
            {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/List_of_students_selected_for_Summer_Internships_2025_25.pdf",
                Text: "Selected Students List",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                },
                glowstatus: "yes"
            },
           
        ]
        },

        {
            AdvertisementDate: <> 01.02.2025 </>,
            NameofthePost: <>Graduate Apprentice (19 Positions)<br/><br/>Technician (Diploma Apprentice) (07 Positions)</> ,
            Advertisement: [
                {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTP_APPRENTICESHIP_25-26_01.pdf",
                Text: "Advertisement for 1-year Apprenticeship Training Programme for Graduate/Diploma under NATS",
                // Style: {
                //     color: "blue"
                // }
               
            },
        ],
            Application: [
                {
                    // Link: "https://docs.google.com/forms/d/e/1FAIpQLSc9FtrjTGsgJEBZ2pnEf4cRjpNxN7L3VxWgQxcoojDQYHASoQ/viewform",
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"   
                }

            ],
            LastDate: <>Last date for submission of application : 28.02.2025</>,
            Status:[
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2025/Provisionally_Selected_Candidates_for_Apprenticeship_Training_2025_26.pdf",
                    Text: "Provisionally Selected Candidates List",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                
                    // glowstatus: "yes"
                    
                },
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/announcements/2025/Date_of_apprentice_selection_process_Updated.pdf",
                //     Text: "Date of Apprenticeship Selection Process",
                //     color: {
                //         color: "darkgreen",
                //         "text-align": "justify"
                //     },
                
                //     glowstatus: "yes"
                    
                // }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/announcements/2025/Apprenticeship_Application_Form_2025.docx",
                //     Text: "Apprenticeship Application Form",
                //     color: {
                //         color: "darkgreen",
                //         "text-align": "justify"
                //     },
                
                //     glowstatus: "yes"
                    
                // },

                // {
                //     Link: "https://files.iittp.ac.in/pdfs/announcements/2025/Screening_Diploma_Apprentice-Physical_Education.pdf",
                //     Text: "1. List of Provisionally Shortlisted and Not Shortlisted Candidates Technical (Diploma) Apprentice - Physical Education",
                //     color: {
                //         color: "darkgreen",
                //         "text-align": "justify"
                //     },
                
                //     glowstatus: "yes"
                    
                // },

                
                
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/announcements/2025/Screening_Diploma_Apprentice-Mathematics&Statistics.pdf",
                //     Text: "2. List of Provisionally Shortlisted and Not Shortlisted Candidates Diploma Apprentice - Mathematics & Statistics",
                //     color: {
                //         color: "darkgreen",
                //         "text-align": "justify"
                //     },
                //     glowstatus: "yes"
                // },

                // {
                //     Link: "https://files.iittp.ac.in/pdfs/announcements/2025/Screening_Diploma_Apprentice-Computer_Science&Engineering.pdf",
                //     Text: "3. List of Provisionally Shortlisted and Not Shortlisted Candidates Diploma Apprentice - Computer Science & Engineering",
                //     color: {
                //         color: "darkgreen",
                //         "text-align": "justify"
                //     },
                //     glowstatus: "yes"
                // },

                // {
                //     Link: "https://files.iittp.ac.in/pdfs/announcements/2025/Screening_Diploma_Apprentice-Institute_Health_Centre.pdf",
                //     Text: "4. List of Provisionally Shortlisted and Not Shortlisted Candidates Diploma Apprentice - Institute Health Centre",
                //     color: {
                //         color: "darkgreen",
                //         "text-align": "justify"
                //     },
                //     glowstatus: "yes"
                // },

                // {
                //     Link: "https://files.iittp.ac.in/pdfs/announcements/2025/Screening_Diploma_Apprentice-Computer_Centre.pdf",
                //     Text: "5. List of Provisionally Shortlisted and Not Shortlisted Candidates Diploma Apprentice - Computer Centre",
                //     color: {
                //         color: "darkgreen",
                //         "text-align": "justify"
                //     },
                //     glowstatus: "yes"
                // },

                // {
                //     Link: "https://files.iittp.ac.in/pdfs/announcements/2025/Screening_Diploma_Apprentice-Civil&ENV.pdf",
                //     Text: "6. List of Provisionally Shortlisted and Not Shortlisted Candidates Diploma Apprentice - Civil & ENV",
                //     color: {
                //         color: "darkgreen",
                //         "text-align": "justify"
                //     },
                //     glowstatus: "yes"
                // },

                // {
                //     Link: "https://files.iittp.ac.in/pdfs/announcements/2025/Screening_Graduate_Apprentice-CoE_SM&EVT_(Electrical).pdf",
                //     Text: "7. List of Provisionally Shortlisted and Not Shortlisted Candidates Graduate Apprentice - CoE SM & EVT (Electrical)",
                //     color: {
                //         color: "darkgreen",
                //         "text-align": "justify"
                //     },
                //     glowstatus: "yes"
                // },

                // {
                //     Link: "https://files.iittp.ac.in/pdfs/announcements/2025/Screening_Grduate_Apprentice-Civil_EV_(Civil).pdf",
                //     Text: "8. List of Provisionally Shortlisted and Not Shortlisted Candidates Grduate Apprentice - Civil & EV (Civil)",
                //     color: {
                //         color: "darkgreen",
                //         "text-align": "justify"
                //     },
                //     glowstatus: "yes"
                // },

                // {
                //     Link: "https://files.iittp.ac.in/pdfs/announcements/2025/Screening Graduate Apprentice - Mechanical Engineering.pdf",
                //     Text: "9. List of Provisionally Shortlisted and Not Shortlisted Candidates Graduate Apprentice - Mechanical Engineering",
                //     color: {
                //         color: "darkgreen",
                //         "text-align": "justify"
                //     },
                //     glowstatus: "yes"
                // },

                // {
                //     Link: "https://files.iittp.ac.in/pdfs/announcements/2025/Screening Graduate Apprentice -CoE SM & EVT (Mechanical).pdf",
                //     Text: "10. List of Provisionally Shortlisted and Not Shortlisted Candidates Graduate Apprentice -CoE SM & EVT (Mechanical)",
                //     color: {
                //         color: "darkgreen",
                //         "text-align": "justify"
                //     },
                //     glowstatus: "yes"
                // },

                // {
                //     Link: "https://files.iittp.ac.in/pdfs/announcements/2025/Screening Graduate Apprentice - Physics.pdf",
                //     Text: "11. List of Provisionally Shortlisted and Not Shortlisted Candidates Graduate Apprentice - Physics",
                //     color: {
                //         color: "darkgreen",
                //         "text-align": "justify"
                //     },
                //     glowstatus: "yes"
                // },

                // {
                //     Link: "https://files.iittp.ac.in/pdfs/announcements/2025/Screening Graduate Apprentice - Institute Health Centre.pdf",
                //     Text: "12. List of Provisionally Shortlisted and Not Shortlisted Candidates Graduate Apprentice - Institute Health Centre",
                //     color: {
                //         color: "darkgreen",
                //         "text-align": "justify"
                //     },
                //     glowstatus: "yes"
                // },

                // {
                //     Link: "https://files.iittp.ac.in/pdfs/announcements/2025/Screening Graduate Apprentice - Electrical Engineeing.pdf",
                //     Text: "13. List of Provisionally Shortlisted and Not Shortlisted Candidates Graduate Apprentice - Electrical Engineeing",
                //     color: {
                //         color: "darkgreen",
                //         "text-align": "justify"
                //     },
                //     glowstatus: "yes"
                // },

                // {
                //     Link: "https://files.iittp.ac.in/pdfs/announcements/2025/Screening Graduate Apprentice - Civil & EV (Chemistry or Micro Bio).pdf",
                //     Text: "14. List of Provisionally Shortlisted and Not Shortlisted Candidates Graduate Apprentice - Civil & EV (Chemistry or Micro Bio)",
                //     color: {
                //         color: "darkgreen",
                //         "text-align": "justify"
                //     },
                //     glowstatus: "yes"
                // },

                // {
                //     Link: "https://files.iittp.ac.in/pdfs/announcements/2025/Screening Graduate Apprentice - HSS.pdf",
                //     Text: "15. List of Provisionally Shortlisted and Not Shortlisted Candidates Graduate Apprentice - HSS",
                //     color: {
                //         color: "darkgreen",
                //         "text-align": "justify"
                //     },
                //     glowstatus: "yes"
                // },

                // {
                //     Link: "https://files.iittp.ac.in/pdfs/announcements/2025/Screening Graduate Apprentice - Engineering Unit (Electrical).pdf",
                //     Text: "16. List of Provisionally Shortlisted and Not Shortlisted Candidates Graduate Apprentice - Engineering Unit (Electrical)",
                //     color: {
                //         color: "darkgreen",
                //         "text-align": "justify"
                //     },
                //     glowstatus: "yes"
                // },

                // {
                //     Link: "https://files.iittp.ac.in/pdfs/announcements/2025/Screening Graduate Apprentice - Engineering Unit (Civil).pdf",
                //     Text: "17. List of Provisionally Shortlisted and Not Shortlisted Candidates Graduate Apprentice - Engineering Unit (Civil)",
                //     color: {
                //         color: "darkgreen",
                //         "text-align": "justify"
                //     },
                //     glowstatus: "yes"
                // },

                // {
                //     Link: "https://files.iittp.ac.in/pdfs/announcements/2025/Screening Graduate Apprentice - Central Library.pdf",
                //     Text: "18. List of Provisionally Shortlisted and Not Shortlisted Candidates Graduate Apprentice - Central Library",
                //     color: {
                //         color: "darkgreen",
                //         "text-align": "justify"
                //     },
                //     glowstatus: "yes"
                // },

                // {
                //     Link: "https://files.iittp.ac.in/pdfs/announcements/2025/Screening Graduate Apprentice - Administration.pdf",
                //     Text: "19. List of Provisionally Shortlisted and Not Shortlisted Candidates Graduate Apprentice - Administration",
                //     color: {
                //         color: "darkgreen",
                //         "text-align": "justify"
                //     },
                //     glowstatus: "yes"
                // },

                // {
                //     Link: "https://files.iittp.ac.in/pdfs/announcements/2025/Screening Graduate Apprentice - Chemical Engineering.pdf",
                //     Text: "20. List of Provisionally Shortlisted and Not Shortlisted Candidates Graduate Apprentice - Chemical Engineering",
                //     color: {
                //         color: "darkgreen",
                //         "text-align": "justify"
                //     },
                //     glowstatus: "yes"
                // },

                // {
                //     Link: "https://files.iittp.ac.in/pdfs/announcements/2025/Screening Graduate Apprentice - Central Workshop.pdf",
                //     Text: "21. List of Provisionally Shortlisted and Not Shortlisted Candidates Graduate Apprentice - Central Workshop",
                //     color: {
                //         color: "darkgreen",
                //         "text-align": "justify"
                //     },
                //     glowstatus: "yes"
                // },

                // {
                //     Link: "https://files.iittp.ac.in/pdfs/announcements/2025/Screening Graduate Apprentice - Chemistry.pdf",
                //     Text: "22. List of Provisionally Shortlisted and Not Shortlisted Candidates Graduate Apprentice - Chemistry",
                //     color: {
                //         color: "darkgreen",
                //         "text-align": "justify"
                //     },
                //     glowstatus: "yes"
                // },

                // {
                //     Link: "https://files.iittp.ac.in/pdfs/announcements/2025/List_of_Candidate_Not_Considered_as_not_Advertised.pdf",
                //     Text: "23. List of Candidate Not Considered as not Advertised",
                //     color: {
                //         color: "darkgreen",
                //         "text-align": "justify"
                //     },
                //     glowstatus: "yes"
                // }
        ]
        },
          

        {
            AdvertisementDate: <> 14.10.2024 </>,
            NameofthePost: "Library Information Assistant - Interns (04 Positions)",
            Advertisement:[ {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/IITTLIB-INTERNAdvt.2024-2501_Notification_Library_Information_Assistant_Interns.pdf",
                Text: "Notification for the position of Library Information Assistant - Interns for Central Library",
                // Style: {
                //     color: "blue"
                // }
               
            },
        ],
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    glowstatus : "no"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 30.10.2024 <br /><br />Tentative date of selection process : <s>20.11.2024</s> 29.11.2024</>,
            Status:
            [ 
            {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTLIB-INTERNAdvt.2024-2501_Library_Intern_Selected_List_2024_25.pdf",
                Text: "Selected Candidates List",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                },
                // glowstatus: "yes"
            },
            {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/IITTLIB-INTERNAdvt.2024-2502_Lib_Interns_SL_and_NSL.pdf",
                Text: "Provisionally Shortlisted and Not Shortlisted Candidates List",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 04.03.2024 </>,
            NameofthePost: "Summer Internship for Students",
            Advertisement:
            [ 
                {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Internship_Notification_2024.pdf",
                Text: "Notification for two months of Summer Internship at IIT Tirupati",
                // Style: {
                //     color: "blue"
                // }
               
            },
            {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Summer_Internship_2024_Corrigendum.pdf",
                Text: "Corrigendum",
                // Style: {
                //     color: "blue"
                // }
               
            },
        ],
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    glowstatus : "no"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : <s>31.03.2024</s> 03.04.2024 upto 5 PM (Extended)</>,
            Status:
            [ 
            {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Summer_Internship_Results.pdf",
                Text: "Selected Students List",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                },
                // glowstatus: "yes"
            },
           
        ]
        },
        {
            AdvertisementDate: <> 31.10.2023 </>,
            NameofthePost: "Library Information Assistant - Interns (05 Positions)",
            Advertisement:
            [ {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2023/IITTPLIBINTERNAdvt.2023-2401.pdf",
                Text: "Notification for the position of Library Information Assistant - Interns for Central Library",
                // Style: {
                //     color: "blue"
                // }
               
            },
        ],
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 15.11.2023 <br /><br />Tentative date of selection process : 29.11.2023</>,
            Status:[
                 {
                Link: "https://files.iittp.ac.in/pdfs/announcements//2023/IITTPLIBINTERNAdvt%202023-2401_Result.pdf",
                Text: "Selected Candidates List",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2023/IITTPLIBInterns2023-2404_Short%20listed_LIA_Interns_2023.pdf",
                Text: "Provisionally Shortlisted and Not Shortlisted Candidates List",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 01.09.2023 </>,
            NameofthePost: <>Graduate Apprentice (09 Positions)<br/><br/>Technician (Diploma Apprentice) (07 Positions)</> ,
            Advertisement:[ {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2023/Apprenticeship/Advt.%20No.%20IITTPAPPRENTICESHIP202301_Apprenticeship_Advertisement.pdf",
                Text: "Advertisement for 1-year Apprenticeship Training Programme for Graduate/Diploma under NATS",
                // Style: {
                //     color: "blue"
                // }
               
            },
        ],
            Application: [
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2023/Apprenticeship/Apprenticeship%20Annexure-A.pdf",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : Extended till 03.10.2023</>,
            Status:[
                 {
                Link: "https://files.iittp.ac.in/pdfs/announcements//2023/Apprenticeship_Selection_Result.pdf",
                Text: "Selected Candidates List",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2023/Apprenticeship%20shortlisted%20&%20Not%20shortlisted%20Candiates.pdf",
                Text: "Provisionally Shortlisted Candidates List",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        }
          

        

    ]


   
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Internship and Apprenticeship" />
            <section className="project-detail">
                <div className="container">
                    <div className="c-heading">
                        <h1>Internship and Apprenticeship</h1>
                    </div>

                    <Row>
                        <div className="card-body">

                            
                                    <Table bordered responsive className="mt-3 table table-striped">
                                    <thead>
                                        <tr className='c-tablehead'>
                                        <th>
                                        Date
                                            </th>
                                            <th>
                                                Name of the Post
                                            </th>
                                            <th>Advertisement</th>
                                            <th>
                                                Application
                                            </th>
                                            <th>
                                                Last Date
                                            </th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                    
                                    <tbody>
                                        {InternsApprentice.map((item, index) => (
                                            <tr key={index}>
                                                 <td>{item.AdvertisementDate}</td>
                                                <td>{item.NameofthePost}</td>
                                                {/* <td>
                                                    {typeof item.Advertisement === 'string' ? item.Advertisement : (
                                                       
                                                        
                                                        <a href={item.Advertisement.Link} style={{ color: (item.Advertisement.Style && item.Advertisement.Style.color) }} target="_blank" >
                                                            {item.Advertisement.Text} 
                                                            <span> (Click Here <i className="icon fas fa-file-pdf" style={{color:"red"}}></i>)</span>
                                                        </a>
                                                   
                                                    )}
                                                </td> */}
                                                <td>
                                                    {Array.isArray(item.Advertisement) ? (
                                                        item.Advertisement.map((Advertisement, idx) => (
                                                            <div key={idx}>
                                                                <a className={`text-maroon ${Advertisement.glowstatus === "yes" ? 'glowing-text' : ''}`} href={Advertisement.Link} style={{ color: (Advertisement.color || (Advertisement.Style && Advertisement.Style.color)) }} target="_blank" >
                                                                {Advertisement.Text}
                                                                <span> (Click Here <i className="icon fas fa-file-pdf" style={{color:"red"}}></i>)<br /><br /></span>
                                                                </a>
                                                            </div>
                                                        ))
                                                    ) : (
                                                            <a className={`text-marron ${item.Advertisement.glowstatus == "yes" ? 'glowing-text' : ''}`} href={item.Advertisement.Link} style={{ color: (item.Advertisement.Style && item.Advertisement.Style.color) }} target="_blank" >
                                                            {item.Advertisement.Text}
                                                        </a>
                                                    )
                                                    
                                                    }
                                                </td>
                                                <td>
                                                    {item.Application.map((status, i) => (
                                                        <div key={i}>
                                                            <a className={`text-maroon ${status.glowstatus === "yes" ? 'glowing-text' : ''}`} href={status.Link} target="_blank" >{status.Text}</a>
                                                        </div>
                                                    ))}
                                                </td>
                                                <td><span><i className="icon fas fa-calendar" style={{color:"steelblue"}}> </i> </span>{item.LastDate}</td>
                                                <td>
                                                    {Array.isArray(item.Status) ? (
                                                        item.Status.map((status, idx) => (
                                                            <div key={idx}>
                                                                <a className={`text-maroon ${status.glowstatus === "yes" ? 'glowing-text' : ''} ${status.strikeOut === "yes" ? 'text-decoration-line-through' : ''} `} href={status.Link} style={{ color: (status.color || (status.Style && status.Style.color)) }} target="_blank" >
                                                                {status.Text}
                                                                <span> 
                                                                    {/* (Click Here <i className="icon fas fa-file-pdf" style={{color:"red"}}></i>) */}
                                                                    <br /><br /></span>
                                                                </a>
                                                            </div>
                                                        ))
                                                    ) : (
                                                            <a className={`text-marron ${item.Status.glowstatus == "yes" ? 'glowing-text' : ''} ${item.Status.strikeOut === "yes" ? 'text-decoration-line-through' : ''}`} href={item.Status.Link} style={{ color: (item.Status.Style && item.Status.Style.color) }} target="_blank" >
                                                            {item.Status.Text}
                                                        </a>
                                                    )
                                                    
                                                    }
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                            
                                    </Table>     
                        </div>
   
                    </Row>
                </div>
            </section>
        </>
    );
}

export default Main;
